import { Badge, Card, Col, Placeholder, Row } from "react-bootstrap";
import { LLMDashboardMarkdownRenderer } from "../common/LLMDashboardMarkdownRenderer";
import { ScanMulti } from "../common/models";

export const SectionChartingButton = (props: {
    isLoading: boolean,
    scanMulti: any,
    idx: number,
    active?: number,
    setActive: (active: number) => void,
    data: any,
    title: string,
    color: string
}) => {

    return (
        <Card onClick={() => {props.setActive(props.idx)}} className={`notes-section ${props.data && props.data.confidence === "Likely" && "orange-bg"} ${props.data && props.data.confidence === "Possible" && "yellow-bg"} ${props.active === props.idx && "notes-section-active"}`}>
            <Card.Body>
                <Row>
                    <Col md={10}>
                        <strong>{props.title}</strong>
                    </Col>
                    <Col md={2} className="text-right">
                        {
                            props.data && props.data.confidence && (
                                <small><Badge bg="warning">{props.data.confidence}</Badge></small>
                            )
                        }
                    </Col>
                </Row>
                {
                    props.isLoading ? (
                        <Placeholder animation="glow">
                            <Placeholder xs={4} />
                        </Placeholder>
                    ) : props.data && props.data.error ? (
                        <Row>
                            <Col>{props.data.error}</Col>
                        </Row>
                    ) : props.data && props.data.summary ? (
                        <Row>
                            <Col className="description-text">
                                <LLMDashboardMarkdownRenderer content={props.data.summary} scanMulti={props.scanMulti} />
                            </Col>
                        </Row>
                    ) : props.data && typeof props.data === 'string' ? (
                        <Row>
                            <Col className="description-text">
                                <LLMDashboardMarkdownRenderer content={props.data} scanMulti={props.scanMulti} />
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col className="description-text">
                                No Data
                            </Col>
                        </Row>
                    )
                }
            </Card.Body>
        </Card>
    );
};
